import React from 'react'
import { Button, Flex, Modal, toast } from '@workwhile/ui'
import { parseErrorMessage } from 'api'
import { ShiftWorkBreak } from 'api/shifts/getShiftWorkBreaks'
import { useRecordShiftWorkBreakMutation } from 'queries/shifts'
import { EDIT_BREAK_FORM_ID, EditBreakForm } from './EditBreakForm'

type EditBreakModalProps = {
  shiftId: number
  workId: number
  shiftWorkBreak: ShiftWorkBreak
  timezone: string
  clockedInAt?: string | null
  clockedOutAt?: string | null
  onClose: () => void
}

export const EditBreakModal = ({
  shiftId,
  workId,
  shiftWorkBreak,
  timezone,
  clockedInAt,
  clockedOutAt,
  onClose,
}: EditBreakModalProps) => {
  const { mutate, isPending, error } = useRecordShiftWorkBreakMutation(shiftId)

  return (
    <Modal
      open={true}
      onClose={onClose}
      position="center"
      loading={isPending}
      title={`Edit break ${shiftWorkBreak.breakNumber}`}
      customCta={
        <Flex>
          <Button variant="text" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" form={EDIT_BREAK_FORM_ID}>
            Save
          </Button>
        </Flex>
      }
    >
      <EditBreakForm
        shiftWorkBreak={shiftWorkBreak}
        timezone={timezone}
        clockedInAt={clockedInAt}
        clockedOutAt={clockedOutAt}
        errorMessage={error ? parseErrorMessage(error) : undefined}
        onSubmit={(request) =>
          mutate(
            { workId, breakNumber: shiftWorkBreak.breakNumber, ...request },
            {
              onSuccess: () => {
                toast.success(`Recorded break ${shiftWorkBreak.breakNumber}.`, {
                  position: 'top-center',
                })
                onClose()
              },
            }
          )
        }
      />
    </Modal>
  )
}
